import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export default async function updateEmployerAllowance(
  businessId,
  allowanceId,
  employerAllowanceUpdateAttributes,
  activeEmployerInfo
) {
  const apiPath = `employer-allowances/${businessId}/update/${allowanceId}`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: employerAllowanceUpdateAttributes,
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);

  return response.data;
}
